module.exports = __webpack_public_path__ + "img/tooltip_for_monthly_book.50fd8fb7.svg";